import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import { Link } from 'react-router-dom';

function CarteAssistant({ assistant }) {
  const disponible = assistant.statut === 'disponible';
  const contenu = (
    <Card className="bg-primary rounded-lg" style={{ height: '100%', opacity: disponible ? 0.95 : 0.7 }}>
      <CardActionArea disabled={!disponible} style={{ height: '100%' }}>
        <CardContent>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
            <Typography className="text-primary" gutterBottom variant="h5" component="h2">
              {assistant.titre}
            </Typography>
            <Chip
              size="small"
              color={disponible ? 'primary' : 'default'}
              label={disponible ? 'Disponible' : 'A venir'}
            />
          </div>
          <Typography className="text-primary" variant="body2" color="textSecondary" component="p">
            {assistant.resume}
          </Typography>
          {assistant.etapes.length > 0 && (
            <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: 12 }}>
              {assistant.etapes.length} etapes configurees
            </Typography>
          )}
        </CardContent>
      </CardActionArea>
      <CardActions>
        {disponible ? (
          <Button size="small" color="primary" component={Link} to={assistant.chemin}>
            Ouvrir
          </Button>
        ) : (
          <Button size="small" disabled>
            A venir
          </Button>
        )}
      </CardActions>
    </Card>
  );

  if (!disponible) {
    return contenu;
  }

  return (
    <Link to={assistant.chemin} style={{ textDecoration: 'none' }}>
      {contenu}
    </Link>
  );
}

function AccueilAssistantsDeploiement({ assistants }) {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper className="rounded-lg bg-primary" style={{ padding: 16 }}>
          <Typography className="text-primary" variant="h4">
            Ingenierie - Assistants de deploiement
          </Typography>
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
            Choisissez le workflow adapte au type de deploiement. Chaque assistant porte sa configuration, ses etapes, ses composants et ses validations.
          </Typography>
        </Paper>
      </Grid>

      {assistants.map((assistant) => (
        <Grid item xs={12} md={6} lg={3} key={assistant.id}>
          <CarteAssistant assistant={assistant} />
        </Grid>
      ))}
    </Grid>
  );
}

export default AccueilAssistantsDeploiement;



// WEBPACK FOOTER //
// src/components/deploiements/AccueilAssistantsDeploiement.js